import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './RobotAnimation.scss';
import Sikibot from '../../assets/common/resources/Sikibot.png';
import RandomMessage from './RandomMessage';

const RobotAnimation = () => {
  const [clickCount, setClickCount] = useState(0);
  const [showStars, setShowStars] = useState(false);
  const [messageTrigger, setMessageTrigger] = useState(0);

  const handleClick = () => {
    setClickCount((prevCount) => (prevCount + 1) % 4);
    setMessageTrigger((prev) => prev + 1); // Increment to trigger new message

    // Control stars separately
    setShowStars(false);
    setTimeout(() => setShowStars(true), 10);
    setTimeout(() => setShowStars(false), 1000);
  };

  const positions = [
    { x: '10%', y: '-140%', rotate: 0 },
    { x: '-30%', y: '-50%', rotate: -90 },
    { x: '300%', y: '-140%', rotate: 0 },
    { x: '200%', y: '40%', rotate: 180 }
  ];

  const generateStars = () => {
    const stars = [];
    for (let i = 0; i < 100; i++) {
      const size = Math.random() * 20 + 10;
      const delay = Math.random() * 0.1;
      const duration = Math.random() * 0.1 + 0.5;
      const color = `hsl(${Math.random() * 360}, 100%, 50%)`;
      const topPosition = Math.random() * 100;

      stars.push(
        <motion.div
          key={i}
          className="star"
          initial={{ opacity: 0, x: '-30%' }}
          animate={{ opacity: [0, 1, 1, 0], x: '2500%' }}
          transition={{
            delay,
            duration,
            ease: 'easeInOut',
            repeat: 0
          }}
          style={{
            width: size,
            height: size,
            backgroundColor: color,
            borderRadius: '50%',
            position: 'absolute',
            top: `${topPosition}%`,
            zIndex: 2
          }}
        />
      );
    }
    return stars;
  };

  return (
    <div className="frosted-glass-container">
      <motion.div
        className="robot-icon"
        animate={positions[clickCount]}
        transition={{
          type: 'spring',
          stiffness: 70,
          damping: 12,
          duration: 1.5
        }}
        onClick={handleClick}
      >
        <img src={Sikibot} alt="Robot" />
      </motion.div>

      <div className="frosted-glass">
        <div className="banner-text">
          <RandomMessage trigger={messageTrigger} /> {/* Pass trigger */}
        </div>
      </div>

      {showStars && (
        <div className="stars-container">
          {generateStars()}
        </div>
      )}
    </div>
  );
};

export default RobotAnimation;
